import { combineReducers, AnyAction, Reducer } from 'redux';
import GlobalReducer from '../../redux/highgroundGlobalState/reducer';
import ActionCentreReducer from '../../redux/actionCentre/reducer';
import CompanyReducer from '../../redux/companyState/reducer';
import SegmentReducer from '../../redux/segmentEventStatus/reducer';
import MspClientReducer from '../../redux/mspClientStates/reducer';
import { Entities } from './entities/entities.enum';

export interface IRootReducer {
  [Entities.AuthUser]: any;
  global: ReturnType<typeof GlobalReducer>;
  company: ReturnType<typeof CompanyReducer>;
  segment: ReturnType<typeof SegmentReducer>;
  actioncentre: ReturnType<typeof ActionCentreReducer>;
  mspclient: ReturnType<typeof MspClientReducer>;
  [key: string]: any;
}

export const RESET_STORE = 'RESET_STORE';

export const rootReducer = (reducers: any): Reducer<IRootReducer> => {
  const combinedReducers = combineReducers({
    ...reducers,
    global: GlobalReducer,
    company: CompanyReducer,
    segment: SegmentReducer,
    actioncentre: ActionCentreReducer,
    mspclient: MspClientReducer,
  }) as unknown as Reducer<IRootReducer>;

  const rootReducerWithPersist = (state: IRootReducer | undefined, action: AnyAction) => {
    if (action.type === RESET_STORE) {
      state = undefined;
    }
    
    if (action.type === 'persist/REHYDRATE') {
      const incoming = action.payload;
      if (incoming) {
        return {
          ...state,
          ...incoming,
        };
      }
    }
    return combinedReducers(state, action);
  };

  return rootReducerWithPersist as Reducer<IRootReducer>;
};

export type RootState = IRootReducer;
